export const featureIconDictionary = {
  dormitorios: 'bed',
  suites: 'suite',
  vagas_garagem: 'vacancies',
  banheiros: 'bathroom',
  varanda: 'balcony',
  copas: 'bed',
  cozinhas: 'kitchen',
  salas: 'livingroom',
  piscinas: 'pool',
  lavabos: 'bathsink',
  despensas: 'storeroom',
  banheiro_empregada: 'servicebath',
  dormitorio_empregada: 'serviceroom',
  areas_servico: 'servicearea',
  escritorio: 'desk',
  area_comum: 'footage',
  area_construida: 'footage',
  area_privativa: 'footage',
  area_terreno: 'footage',
  area_total: 'footage',
  area_util: 'footage',
}

export const featureNameDictionary = {
  dormitorios: 'Dormitório(s)',
  suites: 'Suíte(s)',
  vagas_garagem: 'Vaga(s) na Garagem',
  banheiros: 'Banheiro(s)',
  varanda: 'Varanda(s)',
  copas: 'Copa(s)',
  cozinhas: 'Cozinha(s)',
  salas: 'Sala(s)',
  lavabos: 'Lavabo(s)',
  despensas: 'Despensa(s)',
  banheiro_empregada: 'Banheiro de empregado',
  dormitorio_empregada: 'Dormitório de empregado',
  areas_servico: 'Área de serviço',
  piscinas: 'Piscina',
  escritorio: 'Escritório(s)',
  area_comum: 'Área comum',
  area_construida: 'Área construida',
  area_privativa: 'Área privativa',
  area_terreno: 'Área do Terreno',
  area_total: 'Área total',
  area_util: 'Área útil',
}
